module.exports = __webpack_public_path__ + "img/school7.c42ed85a.png";